import { FieldProps } from "formik";
import React from "react";
import Select, { Option, ReactSelectProps } from "react-select";

const SelectField: React.FC<ReactSelectProps & FieldProps> = ({
  options,
  field,
  placeholder,
  form,
  onChange,
  error,
}) => {
  const setValue =
    field.name === "occupation"
      ? options.find((option) => option.label === field.value)
      : options.find((option) => option.value === field.value);

  return (
    <Select
      options={options}
      name={field.name}
      placeholder={placeholder}
      value={options ? setValue : ""}
      onChange={
        onChange
          ? onChange
          : (option: Option) => form.setFieldValue(field.name, option.value)
      }
      onBlur={field.onBlur}
      className={`${error ? "is-invalid" : ""}`}
    />
  );
};

export default SelectField;
